export const module = {
  info: {
    name: 'voip-destination-sms',
    caption: 'voip destination sms'
  },
  vuexModules: ['api'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
